import { translate } from 'react-i18nify';
import TimeUtils from "./TimeUtils";

class DownloadData {


    createRow  = (patientSession, treatment, component, session, dsValue) => {
        const hl7Patient = patientSession?.patient.patient;   
        let row = [];
        row.push( 
            //Adding patient data
            hl7Patient?.id.value,      
            hl7Patient?.identifier ? hl7Patient?.identifier[0]?.system.value : null,
            hl7Patient?.identifier ? hl7Patient?.identifier[0]?.value.value : null,
            patientSession?.patient.location.id,
            patientSession?.patient.location.name,

            //Adding treatment data
            treatment?.id,        
            treatment?.name,
            treatment?.values?.find(value => value.code === "DurLod1")?.value, //Analysing phase duration
            treatment?.values?.find(value => value.code === "Ki")?.value, //Flow response rate
            treatment?.values?.find(value => value.code === "OAD")?.value, //Fraction of time with pulse oximeter
            treatment?.values?.find(value => value.code === "HSpO2")?.value, //Upper SpO2 target range
            treatment?.values?.find(value => value.code === "LSpO2")?.value, //Lower SpO2 target range
            treatment?.values?.find(value => value.code === "HO2LT")?.value, //Upper O2 target range without sensor
            treatment?.values?.find(value => value.code === "LO2LT")?.value, //Lower O2 target range without sensor
            treatment?.values?.find(value => value.code === "HO2ST")?.value, //Upper O2 target range with sensor
            treatment?.values?.find(value => value.code === "LO2ST")?.value, //Lower O2 target range with sensor

            component?.metaData?.find(metaData => metaData.metadataId === 1)?.value, //Serial number

            //Adding detailed session data
            dsValue?.o2,
            dsValue?.pulse,
            dsValue?.spO2,
            dsValue ? TimeUtils.dateStringToLocalTimeString(dsValue?.timestamp) : dsValue?.timestamp,
            dsValue?.timestamp, //Timestamp as UTC
            
            //Adding sessions data         
            session?.id,
            session ? TimeUtils.dateStringToLocalTimeString(session?.parts.start.timestamp) : session?.parts.start.timestamp,
            session?.parts.start.timestamp, //Timestamp as UTC
            session?.parts.start.values.SpO2Initial,
            session?.parts.start.values.PulseInitial,
            session?.parts.start.values.OxygenInitial,
            session ? TimeUtils.dateStringToLocalTimeString(session?.parts.analyzing.timestamp) : session?.parts.analyzing.timestamp,
            session?.parts.analyzing.timestamp, //Timestamp as UTC
            session?.parts.analyzing.values.SpO2Average,
            session?.parts.analyzing.values.SpO2Maximum,
            session?.parts.analyzing.values.SpO2Minimum,
            session?.parts.analyzing.values.SpO2StandardDeviation,
            session?.parts.analyzing.values.PulseAverage,
            session?.parts.analyzing.values.PulseMaximum,
            session?.parts.analyzing.values.PulseMinimum,
            session?.parts.analyzing.values.PulseStandardDeviation,
            session?.parts.analyzing.values.OxygenAverage,
            session?.parts.analyzing.values.OxygenMaximum,
            session?.parts.analyzing.values.OxygenMinimum,
            session?.parts.analyzing.values.OxygenStandardDeviation,
            session ? TimeUtils.dateStringToLocalTimeString(session?.parts.adjusting.timestamp) : session?.parts.adjusting.timestamp,
            session?.parts.adjusting.timestamp, //Timestamp as UTC
            session?.parts.adjusting.values.SpO2Average,
            session?.parts.adjusting.values.SpO2Maximum,
            session?.parts.adjusting.values.SpO2Minimum,
            session?.parts.adjusting.values.SpO2StandardDeviation,
            session?.parts.adjusting.values.PulseAverage,
            session?.parts.adjusting.values.PulseMaximum,
            session?.parts.adjusting.values.PulseMinimum,
            session?.parts.adjusting.values.PulseStandardDeviation,
            session?.parts.adjusting.values.OxygenAverage,
            session?.parts.adjusting.values.OxygenMaximum,
            session?.parts.adjusting.values.OxygenMinimum,
            session?.parts.adjusting.values.OxygenStandardDeviation,
            session ? TimeUtils.dateStringToLocalTimeString(session?.parts.end.timestamp) : session?.parts.end.timestamp,
            session?.parts.end.timestamp, //Timestamp as UTC
            session ? TimeUtils.dateStringToLocalTimeString(session?.parts.end.values.NextDiagnosis) : session?.parts.end.values.NextDiagnosis,
            session?.parts.end.values.NextDiagnosis, //Timestamp as UTC
            session?.parts.end.values.SpO2Final,
            session?.parts.end.values.PulseFinal,
            session?.parts.end.values.OxygenTarget,
            session?.parts.end.values.Zone,
        )
        return row;
    }

    findSession = (sessions, detailedSessionValue) => {

        const session = sessions.find(session => {
            return TimeUtils.dateToUTC(new Date(session.parts.start.timestamp)) <= TimeUtils.dateToUTC(new Date(detailedSessionValue.timestamp)) && TimeUtils.dateToUTC(new Date(session.parts.end.timestamp)) >= TimeUtils.dateToUTC(new Date(detailedSessionValue.timestamp))
        })
        if(session){
            session.linkedToDetailedValue = true;
        }
        return session;
    }

    findTreatment = (treatments, treatmentId) => {
        const treatment = treatments.find(treatment => treatment.id === treatmentId);
        return treatment;
    }

    findComponent = (components, componentId) => {
        const component = components.find(component => component.id === componentId);
        return component;
    }

    donwloadCsv = (data, anonPatient, from, to, setLoading) => {
        let rows = [
            ["sep=;"],
            [
                //Patient goes here but it is added after this array is initiated. 
                translate("TreatmentId"), //Treatment
                translate("TreatmentName"),
                translate("AnalysingPhaseDuration(s)"), 
                translate("FlowResponse") + "(s)",
                translate("ShortTermLength") + "(s)",
                translate("SpO2RangeMax") + " (%)",
                translate("SpO2RangeMin") + " (%)",
                translate("O2RangeMaxWithout") + " (l/min)",
                translate("O2RangeMinWithout") + " (l/min)",
                translate("O2RangeMaxWith") + " (l/min)",
                translate("O2RangeMinWith") + " (l/min)",

                //Component 
                translate("DeviceSerialNumber"),

                translate("O2") + " (l/min)", // Detailed session data
                translate("Pulse") + " (bpm)",
                translate("SpO2") + " (%)",
                translate("LocalTimestamp"),
                translate("UTCTimestamp"),

                translate("SessionId"), //Sessions Start
                translate("Start") + " " + translate("LocalTimestamp"), //Start
                translate("Start") + " " + translate("UTCTimestamp"), //Start
                translate("SpO2Initial") + " (%)",
                translate("PulseInitial") + " (bpm)",
                translate("O2FlowInitial") + " (l/min)",
                translate("Analysing") + " " + translate("LocalTimestamp"), //Analysing
                translate("Analysing") + " " + translate("UTCTimestamp"),
                translate("SpO2Average") + " (%)",
                translate("SpO2Max") + " (%)",
                translate("SpO2Min") + " (%)",
                translate("SpO2StandardDeviation"),
                translate("PulseAverage") + " (bpm)",
                translate("PulseMax") + " (bpm)",
                translate("PulseMin") + " (bpm)",
                translate("PulseStandardDeviation"),
                translate("O2FlowAverage") + " (l/min)",
                translate("O2FlowMax") + " (l/min)",
                translate("O2FlowMin") + " (l/min)",
                translate("O2FlowStandardDeviation"),
                translate("Adjusting") + " " + translate("LocalTimestamp"), //Adjusting
                translate("Adjusting") + " " + translate("UTCTimestamp"),
                translate("SpO2Average") + " (%)",
                translate("SpO2Max") + " (%)",
                translate("SpO2Min") + " (%)",
                translate("SpO2StandardDeviation"),
                translate("PulseAverage") + " (bpm)",
                translate("PulseMax") + " (bpm)",
                translate("PulseMin") + " (bpm)",
                translate("PulseStandardDeviation"),
                translate("O2FlowAverage") + " (l/min)",
                translate("O2FlowMax") + " (l/min)",
                translate("O2FlowMin") + " (l/min)",
                translate("O2FlowStandardDeviation"),
                translate("End") + " " + translate("LocalTimestamp"), //End
                translate("End") + " " + translate("UTCTimestamp"),
                translate("NextSessionTime") + " " + translate("LocalTimestamp"),
                translate("NextSessionTime") + " " + translate("UTCTimestamp"),
                translate("SpO2Final") + " (%)",
                translate("PulseFinal") + " (bpm)",
                translate("O2FlowTarget") + " (l/min)",
                translate("Zone"),
            ]
        ]
        if(anonPatient === true) {
            rows[2].unshift(translate("AnonymizedPatientId"));
            rows[2].unshift(translate("DateOfBirth"));
            rows[2].unshift(translate("Gender"));
            data.forEach(patientSession => {
            
                data.detailedSessions.forEach(ds => {
                    let session = this.findSession(patientSession, ds.values[0]);
                    ds.values.forEach(value => {
                        if(session == null || !(TimeUtils.dateToUTC(new Date(session.parts.start.timestamp)) <= TimeUtils.dateToUTC(new Date(value.timestamp)) && TimeUtils.dateToUTC(new Date(session.parts.end.timestamp)) >= TimeUtils.dateToUTC(new Date(value.timestamp))))
                            session = this.findSession(patientSession, value);
                        const component = this.findComponent(data.components, value.componentId);


                        const rowWithValue = this.createRow(patientSession, ds.treatment, component, session, value);
                        rows.push(rowWithValue);
                    })
                })
    
                const notLinkedSessions = patientSession.sessions.filter(session => !session.linkedToDetailedValue);
                notLinkedSessions.forEach(session => {
                    const rowWithValue = this.createRow(patientSession, session.treatment, session.component, session, undefined);
                    rows.push(rowWithValue);
                })
            });
        }
        else{
            rows[1].unshift(translate("Patient") + " " +translate("Location"));
            rows[1].unshift(translate("Patient") + " " +translate("LocationId"));
            rows[1].unshift(translate("IdentifierValue"));
            rows[1].unshift(translate("IdentifierType"));
            rows[1].unshift(translate("PatientId"));

            data.detailedSessions.forEach(ds => {
                let session = this.findSession(data.sessions, ds.values[0]);
                let component = this.findComponent(data.components, ds.values[0].componentId);   
                ds.values.forEach(value => {
                    if(session == null || !(TimeUtils.dateToUTC(new Date(session.parts.start.timestamp)) <= TimeUtils.dateToUTC(new Date(value.timestamp)) && TimeUtils.dateToUTC(new Date(session.parts.end.timestamp)) >= TimeUtils.dateToUTC(new Date(value.timestamp)))){
                        session = this.findSession(data.sessions, value);
                    }
                    if(component == null || component.id !== value.componentId)
                        component = this.findComponent(data.components, value.componentId);   
                    
                    const rowWithValue = this.createRow(data, ds.treatment, component, session, value);
                    rows.push(rowWithValue);
                })
            })
            const notLinkedSessions = data.sessions.filter(session => !session.linkedToDetailedValue).sort(session => session.parts.start.timestamp);
            notLinkedSessions.forEach(session => {
                const component = this.findComponent(data.components, session.component.id);   
                const rowWithValue = this.createRow(data, session.treatment, component, session, undefined);
                rows.push(rowWithValue);
            })
        }
        let csvContent = "data:text/csv;charset=utf-8,"
        + rows.map(e => e.join(";")).join("\n");

        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        if(anonPatient === true)
            link.setAttribute("download", `O2matic -${translate("AnonymizedSessionData")} - ${TimeUtils.formatDateYYMMDD(Date.now())}.csv`);
        else
            link.setAttribute("download", `O2matic - Patient ${data.patient.patient.id.value} - session data - ${TimeUtils.formatDateYYMMDD(from)}  - ${TimeUtils.formatDateYYMMDD(to)}.csv`);
        document.body.appendChild(link);
        link.click();
        setLoading(false);
    }
}

export default new DownloadData();